/*  ========================================================================
    # JavaScript - Landingpage
    ========================================================================  */

import '../react/landingpage/Quotes/index';
import '../react/landingpage/Slider/index';

/**
 * Accordion
 */
const Accordion = {
  cfg: {
    sections: document.querySelectorAll('.s-accordion'),
    classes: {
      entry: 's-accordion__entry',
      entryActive: 's-accordion__entry--active',
      heading: 's-accordion__heading'
    }
  },

  /**
   * Handler.
   *
   * @param {Object} accordion
   */
  handler(accordionObject) {
    accordionObject.entries.forEach(entry => {
      entry.querySelector(`.${this.cfg.classes.heading}`).addEventListener('click', () => {
        entry.classList.toggle(this.cfg.classes.entryActive);
      });
    });
  },

  /**
   * Creates an object for each accordion section on the current page.
   */
  sections() {
    this.cfg.sections.forEach(section => {
      const accordionObject = {
        section,
        entries: section.querySelectorAll(`.${this.cfg.classes.entry}`)
      };

      this.handler(accordionObject);
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.sections !== undefined && this.cfg.sections !== null) this.sections();
  }
};

Accordion.init();

/**
 * Contact
 */
const Contact = {
  cfg: {
    sections: document.querySelectorAll('.s-contact'),
    links: {
      consulting: Array.from(document.querySelectorAll('a')).filter(
        anchor => anchor.getAttribute('href') === '#consulting'
      ),
      offer: Array.from(document.querySelectorAll('a')).filter(
        anchor => anchor.getAttribute('href') === '#offer'
      )
    }
  },

  /**
   * Handle "consulting" and "offer" tabs.
   */
  handler(contactObject) {
    this.cfg.links.consulting.forEach(link => {
      link.addEventListener('click', () => {
        contactObject.tabs.offer.classList.remove('s-contact__form-tab--active');
        contactObject.container.offer.classList.remove('s-contact__form--active');
        contactObject.tabs.consulting.classList.add('s-contact__form-tab--active');
        contactObject.container.consulting.classList.add('s-contact__form--active');
      });
    });

    contactObject.tabs.consulting.addEventListener('click', () => {
      contactObject.tabs.offer.classList.remove('s-contact__form-tab--active');
      contactObject.container.offer.classList.remove('s-contact__form--active');
      contactObject.tabs.consulting.classList.add('s-contact__form-tab--active');
      contactObject.container.consulting.classList.add('s-contact__form--active');
    });

    this.cfg.links.offer.forEach(link => {
      link.addEventListener('click', () => {
        contactObject.tabs.consulting.classList.remove('s-contact__form-tab--active');
        contactObject.container.consulting.classList.remove('s-contact__form--active');
        contactObject.tabs.offer.classList.add('s-contact__form-tab--active');
        contactObject.container.offer.classList.add('s-contact__form--active');
      });
    });

    contactObject.tabs.offer.addEventListener('click', () => {
      contactObject.tabs.consulting.classList.remove('s-contact__form-tab--active');
      contactObject.container.consulting.classList.remove('s-contact__form--active');
      contactObject.tabs.offer.classList.add('s-contact__form-tab--active');
      contactObject.container.offer.classList.add('s-contact__form--active');
    });
  },

  /**
   * Creates an object for each contact section on the current page.
   */
  sections() {
    this.cfg.sections.forEach(section => {
      const contactObject = {
        section,
        tabs: {
          consulting: section.querySelector('#consulting-tab'),
          offer: section.querySelector('#offer-tab')
        },
        container: {
          consulting: section.querySelector('#consulting-form'),
          offer: section.querySelector('#offer-form')
        }
      };

      this.handler(contactObject);
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.sections !== undefined && this.cfg.sections !== null) this.sections();
  }
};

Contact.init();
